import { ReactElement } from "react";
import { sort, SortedField, SortOrder } from "../../../../../shared/sort";
import Arrow from "../../../../DashboardPage/SideNav/Sorting/Arrow";
import styles from "./SortableColumn.module.scss";

interface SortableColumnProps
{
    field: string;
    sortedField: SortedField;
    setSortedField: (sortField: SortedField) => void;
    tableLoadingState: boolean;
}

const SortableColumn = (props: SortableColumnProps): ReactElement =>
{
    const handleSort = (pressedField: string): void =>
    {
        const { sortedField: sortField, setSortedField } = props;
        let newSortedField: SortedField = props.sortedField;

        if (!sortField || (sortField && sortField.caption !== pressedField))
            newSortedField = new SortedField(pressedField, SortOrder.Asc);
        else if (sortField && sortField.caption === pressedField)
            newSortedField = new SortedField(pressedField, sort(props.sortedField.order));

        setSortedField(newSortedField);
    }

    return (
        <button className={styles.sortBtn} onClick={() => handleSort(props.field)} disabled={props.tableLoadingState}>
            <span>
                {props.field}
                <Arrow field={props.field} sortedField={props.sortedField} />
            </span>
        </button>
    );
}

export default SortableColumn;